<div class="modal-header">
    <h3 class="modal-title truncate" *ngIf="!editor.customize.title.hide">
    	<span [innerHTML]="editorData.title | safeHtml"></span>
    </h3>	
    <h5 class="modal-subtitle" *ngIf="!editor.customize.subtitle.hide" 
		ddTextCollapse
		[ddTextCollapseMaxLength]="225" 
		[ddTextCollapseText]="editorData.subtitle"></h5>	
	<button class="close-x btn btn-xs btn-danger" (click)="close()" title="Close the editor"><i class="fa fa-times fa-1x" aria-hidden="true"></i></button>

	<div class='dx-controls-panel' *ngIf="isTaskMode">
		<button class="btn btn-sm btn-primary" title="View task information" (click)="showTaskProperties()">
			{{LOCALIZATION.taskInformation}} <i class="fa fa-info-circle"></i>
		</button>
		<button class="btn btn-sm btn-primary" title="View assigned queries" (click)="showQueriesProperties()">
			{{LOCALIZATION.assignedQueries}} <i class="fa fa-info-circle"></i>
		</button>
		<div class="pull-right">
		    <!-- Deprecated -->
			<!-- div *ngIf="customize.taskDataForm && customize.taskDataForm.name == 'SF715'" class="alert alert-danger decision-alert" style="display: inline-block;">
                <span>
                    {{suggestedDecision}}
                    <i class="fa fa-question-circle pointMe" style="padding-left:5px;" title="View the justification of the suggested decision" (click)="openDecisionJustification()" aria-hidden="true"></i>
                </span>
            </div  -->

			<button *ngIf="!editor.customize.main.hide.referrals" class="btn btn-sm btn-primary" title="View task referrals" (click)="onShowReferrals()">
				{{LOCALIZATION.referrals}} <i class="fa fa-share-alt" aria-hidden="true"></i>
			</button>
			<button *ngIf="!editor.customize.main.hide.referrals" class="btn btn-sm btn-primary" title="Refer the document" (click)="onRefer()">
				{{LOCALIZATION.refer}} <i class="fa fa-share-alt-square" aria-hidden="true"></i>
			</button>
			<button class="btn btn-sm btn-success" title="{{editor.customize.approve.tooltip}}" (click)="onComplete()">
				{{editor.customize.approve.label}} <i class="fa fa-check" aria-hidden="true"></i>
			</button>
			<button *ngIf="editorData.task.actions.canReject" class="btn btn-sm btn-danger" title="Reject the document" (click)="onReject()">
				{{LOCALIZATION.reject}} <i class="fa fa-times-circle" aria-hidden="true"></i>
			</button>
		</div>
	</div>
</div>
<div class='modal-body' [ngClass]="{'dx-no-task' : !isTaskMode, '' : isTaskMode}">
	<div class='dx-viewer-panels'>
		<div class='dx-viewer-side-panel-closed' [ngClass]="{'hide' : states.hitsPanelOpen, '' : !states.hitsPanelOpen}">
			<div class="panel-header">
				<button class="btn pull-left" (click)="toggleHitsPanel()" title="{{LOCALIZATION.annotationsShowHide}} panel" type="button">
					<i class="fa fa-angle-double-right"></i>
				</button>
			</div>
		</div>
		<div class='dx-viewer-side-panel' id='hitsPanel' [ngClass]="{'' : states.hitsPanelOpen, 'hide' : !states.hitsPanelOpen}">
			<div class="panel-header">
				<button class="btn pull-left" (click)="toggleHitsPanel()" title="{{LOCALIZATION.annotationsShowHide}} panel" type="button">
					<i class="fa fa-angle-double-left"></i>
				</button>
				<div class="title">{{LOCALIZATION.annotations}} ({{editor.numHits}})</div>
			</div>
			<div class="text-center" style="padding-bottom: 8px;">
				<button class="btn btn-primary" (click)="showQueriesSelector()" title="Search using query library" type="button">
					{{LOCALIZATION.searchDocument}}
				</button>
			</div>
			<div *ngFor="let entry of editor.hits | keyvalue; let i = index;" [ngClass]="{ 'striped': i % 2 !== 0 }" class="group">
				<div>
					<label style="display:inline-block;" class="control control--checkbox">
						<div class="group-mainheader truncate">{{entry.key}}</div>
						<input type="checkbox" value="{{entry.key}}"
							   [checked]="editor.hitsfilter.groups.indexOf(entry.key) > -1"
							   (click)="showHitsByGroup(entry.key)" />
						<div class="control__indicator" title="{{LOCALIZATION.annotationsShowHide}}"></div>
					</label>
				</div>
				<div *ngFor="let term of entry.value" class="group-container">
					<label class="group-entry control control--checkbox">
						<div class="term-label truncate" title="{{term.label}} ({{term.hits}} Hits)">
							<span style="float:right;">({{term.hits}})</span>
							<span style="display:block;" class="truncate">{{term.label}}</span>
						</div>
						<input type="checkbox" value="{{term.label}}"
							   [checked]="editor.hitsfilter.queries.indexOf(term.label) > -1"
							   [disabled]="editor.hitsfilter.groups.indexOf(entry.key) == -1"
							   (click)="showHitsByQuery(term.label)" />
						<div class="control__indicator" 
							[ngClass]="{'disabled' : (editor.hitsfilter.groups.indexOf(entry.key) == -1)}"
							[ngStyle]="{'background': term.rgbcolor,'border': 'solid 1px ' + term.rgbcolor}"
							title="{{LOCALIZATION.annotationsShowHide}}">
						</div>
					</label>
					<!-- Click the link to jump to the pdf page in the editor -->
					<div style="overflow-wrap:break-word;">
						<span>{{LOCALIZATION.pages}}:</span>
						<span *ngFor="let hit of term.pdfPages; let last = last;">
	  					<a
								class="group-entry-page pointMe" title="Go to page {{hit}}"
								ng-class="{'dx-disabled-link' : (editor.hitsfilter.groups.indexOf(group) == -1 || editor.hitsfilter.queries.indexOf(term.label) == -1 )}"
								(click)="goToPage(hit, term.queryId, term.label)">{{hit}}</a>{{last ? '' : ', '}}
	  					</span>
					</div>
				</div>
			</div>
			<div *ngIf="(editor.hits | isEmpty)" class="text-center"> <i>{{LOCALIZATION.annotationsNone}}.</i></div>
		</div>
		<div *ngIf='viewerURL != null' class='dx-viewer-center-panel' id='fullViewerContainer'>
			<iframe *ngIf='viewerURL' wmode="transparent" id='dxFullViewer' [src]="viewerURL" width="100%" height="100%"></iframe>
		</div>
	</div>
</div>
